<script setup lang="ts">
// The employer's view of a candidate's video résumé; «Пригласить» gets pressed on a loop.
import { useElementVisibility, useIntervalFn } from '@vueuse/core'
import { testimonials } from './landing-content'
import LandingVideo from './LandingVideo.vue'

const questions = ['О себе', 'Почему к нам?', 'График']

const root = useTemplateRef<HTMLElement>('root')
const visible = useElementVisibility(root)
const tick = ref(0)
const invited = computed(() => tick.value % 4 === 3)

const { pause, resume } = useIntervalFn(() => tick.value++, 1300, { immediate: false })
watch(visible, value => value ? resume() : pause())
</script>

<template>
  <div ref="root" class="relative size-full overflow-hidden bg-black text-white">
    <LandingVideo :src="testimonials[0]!.src" class="absolute inset-0 size-full object-cover" />
    <div class="absolute inset-0 bg-[linear-gradient(180deg,rgb(0_0_0/35%)_0%,transparent_20%,transparent_50%,rgb(0_0_0/75%)_100%)]" />

    <div class="absolute inset-x-4 top-12 flex gap-1">
      <span v-for="(question, index) in questions" :key="question" class="h-1 flex-1 overflow-hidden rounded-full bg-white/35">
        <span class="block h-full bg-white" :style="{ width: index < tick % 3 ? '100%' : index === tick % 3 ? '50%' : '0%' }" />
      </span>
    </div>
    <p class="absolute left-4 top-16 rounded-full bg-black/35 px-3 py-1 text-sm backdrop-blur">{{ questions[tick % 3] }}</p>

    <div class="absolute inset-x-4 bottom-6">
      <p class="text-xs uppercase tracking-[0.04em] opacity-90">Артём, 19 лет · Новосибирск</p>
      <p class="mt-1 text-[1.375rem] font-semibold leading-tight">Бариста</p>
      <div class="mt-2 flex flex-wrap gap-1.5 text-xs">
        <span class="rounded-full bg-white/20 px-2.5 py-1 backdrop-blur">Без опыта</span>
        <span class="rounded-full bg-white/20 px-2.5 py-1 backdrop-blur">Вечерние смены</span>
        <span class="rounded-full bg-white/20 px-2.5 py-1 backdrop-blur">Студент</span>
      </div>
      <div class="mt-4 flex items-center gap-2">
        <span
          class="flex h-12 flex-1 items-center justify-center gap-2 rounded-full text-base transition-all duration-300"
          :class="invited ? 'scale-95 bg-status-online' : 'bg-primary'"
        >
          <Icon :name="invited ? 'tabler:check' : 'tabler:send'" class="size-5" />
          {{ invited ? 'Приглашение отправлено' : 'Пригласить' }}
        </span>
        <span class="flex size-12 items-center justify-center rounded-full bg-white/15">
          <Icon name="tabler:heart-filled" class="size-6" />
        </span>
      </div>
    </div>
  </div>
</template>
